import { FC } from "react";
import { useTranslation } from "react-i18next";
import CustomPopup from "../../../custom-components/CustomPopup";
import AccomplishedIconSVG from "../../resources/svg/AccomplishedIconSVG";
import CancelIconSVG from "../../resources/svg/CancelIconSVG";
import ClockIconSVG from "../../resources/svg/ClockIconSVG";

interface SubscriptionSuccessProps {
    isVisible: boolean;
    isSuccess: boolean;
    isActivationConfirmed: boolean;
    setVisible: (value: boolean) => void;
}

const SubscriptionSuccess: FC<SubscriptionSuccessProps> = (props) => {
    const { t } = useTranslation();

    return (
        <CustomPopup
            isVisible={props.isVisible}
            setIsVisible={props.setVisible}
            wrapClassName="dmin2:min-w-[628px] di6:min-w-[428px] ti6:min-w-[428px] ti7:min-w-[340px] tmax4:min-w-[340px] border border-backgroundButton"
            confirmTitle={t("common.ok")}
            confirmHandler={() => props.setVisible(false)}
            confirmButtonClassName="w-[193px] dmax2:w-[133px] h-[50px] dmax2:h-[40px] mt-8 dmax2:mt-6"
        >
            <div className="flex flex-col items-center mt-[10px]">
                {props.isSuccess && props.isActivationConfirmed ? (
                    <AccomplishedIconSVG className="w-14 h-14 dmax2:w-10 dmax2:h-10 text-textWarning mb-4" />
                ) : props.isSuccess ? (
                    <ClockIconSVG className="w-14 h-14 dmax2:w-10 dmax2:h-10 text-textWarning mb-4" />
                ) : (
                    <CancelIconSVG className="w-14 h-14 dmax2:w-10 dmax2:h-10 text-red-500 mb-4" />
                )}
                <p className="H20 dmax2:H16 text-textWhite text-center dmin2:max-w-[420px] di6:max-w-[320px] ti6:max-w-[320px] ti7:max-w-[280px] tmax4:max-w-[280px]">
                    {t(
                        !props.isSuccess
                            ? "subscription.subscriptionError"
                            : props.isActivationConfirmed
                            ? "subscription.subscriptionSuccess"
                            : "subscription.subscriptionPending"
                    )}
                </p>
            </div>
        </CustomPopup>
    );
};

export default SubscriptionSuccess;
